import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, useTheme } from '@mui/material';

interface IGridItemContainerProps {
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
  border?: boolean;
  isHeader?: boolean;
  value?: string;
  children?: React.ReactNode;
}

const BorderedGridItem = styled(Grid)(({ theme }) => ({
  boxShadow: `1px 0 0 0 ${theme.palette.divider}, 0 1px 0 0 ${theme.palette.divider}`,
}));

const GridItemContainer: React.FC<IGridItemContainerProps> = ({ value, children, isHeader, border = false, ...rest }) => {
  const theme = useTheme();
 
  // Render only if value is not empty
  /* if (!value) return null; */

  const backgroundColor = isHeader
    ? theme.palette.mode === 'dark'
      ? theme.palette.grey[800]
      : theme.palette.grey[100]
    : "transparent";

  // Conditionally render BorderedGridItem or Grid based on the border prop
  const ComponentToRender = border ? BorderedGridItem : Grid;

  return (
    <ComponentToRender
      bgcolor={backgroundColor}
      item {...rest}
      p={2}
    >
      {children}
    </ComponentToRender>
  );
};

export default GridItemContainer;
